import React from "react";
import ContractManufacturing from "../../../images/dtn-network-icons/contract-manufacturing.svg";
import { Row, Col } from "react-bootstrap";
import BenefitsCard from "../../BenefitsCard/BenefitsCard";
import { Container } from "@material-ui/core";

export default function PPNServices() {
  const services = [

   
     
    {
      img: ContractManufacturing,
      title: "Agri Contract-Manufacturing Services",
      bodycopy:
      " PPN Network enables Agri Contract-Manufacturing Services, facilitating seamless collaboration between agri-contract manufacturers and brands to streamline production processes and optimize product quality in the agribusiness sector.",
    },
  ];
  return (
    <div className="main-wrapper">
          <Container className="subSectionWrapper ">
      <h2 className="text-center container-title mb-4">
          Services
      </h2>
      <Row className="justify-content-center">
        {services.map((e,index) => {
          return (
            <Col md={6} key={index} className="d-flex">
              <BenefitsCard src={e.img} title={e.title} bodycopy={e.bodycopy} />
            </Col>
          );
        })}
      </Row>
      </Container>
    </div>
  );
}
